import axiosInstance from 'api/axiosInstance';

export async function getPatrolData(
	patrol: ScheduleAssignment,
): Promise<any[]> {
	let url = '/Project/WebService/CANDispatch.asmx/GetPatrolData';

	if (process.env.NODE_ENV === 'production') {
		url = '/Portal' + url;
	}

	const { data } = await axiosInstance({
		method: 'POST',
		url: url,
		data: {
			obj: JSON.stringify(patrol),
		},
	});

	return data.d;
}
